import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import * as moment from 'moment';

@Component({
    selector: 'tyl-cal-widget',
    templateUrl: './tyl-cal-widget.component.html',
    styleUrls: ['./tyl-cal-widget.component.css']
})
export class TylCalWidgetComponent implements OnInit {

    calendarDates: CalendarDay[] = [];
    private _date: string;
    private _nonAttendanceDates: string[];
    private _eventDates: string[];
    @Output() monthChange: EventEmitter<string> = new EventEmitter<string>();
    @Output() dayClick: EventEmitter<string> = new EventEmitter<string>();
    month: string;
    year: string;
    @Input() showBellIcon = false;

    constructor() {
    }

    get nonAttendanceDates(): string[] {
        return this._nonAttendanceDates;
    }

    get date(): string {
        return this._date;
    }

    get eventDates(): string[] {
        return  this._eventDates;
    }

    @Input() set nonAttendanceDates(value: string[]) {
        this._nonAttendanceDates = value;
        if (!this._nonAttendanceDates) {
            this._nonAttendanceDates = [];
        }
        this.populateCalendar();
    }

    @Input() set date(value: string) {
        this._date = value;
        if (!this._date) {
           this._date = moment().format('MM/DD/YYYY');
        }
        this.populateCalendar();
    }

    @Input() set eventDates(value: string[]) {
        this._eventDates = value;
        if (!this._eventDates) {
            this._eventDates = [];
        }
        this.populateCalendar();
    }

    ngOnInit() {}

    populateCalendar() {
        this.calendarDates.length = 42;
        this.month = moment(this.date, 'MM/DD/YYYY').format('MMMM');
        this.year = moment(this.date, 'MM/DD/YYYY').format('YYYY');
        const firstDayOfMonth = moment(this.date, 'MM/DD/YYYY').startOf('month');
        const startOfMonth = moment(this.date, 'MM/DD/YYYY').startOf('month').day();
        const calendarIndex = moment(firstDayOfMonth).add(-startOfMonth, 'day');
        // starting at the indexed day count the dates backwards
        for (let i = 0; i < this.calendarDates.length; i++) {
            this.calendarDates[i] = {
                date: calendarIndex.format('MM/DD/YYYY'),
                day: calendarIndex.date(),
                isToday: (calendarIndex.format('MM/DD/YYYY') == moment().format('MM/DD/YYYY')) ? true : false,
                isCurrentMonth: (calendarIndex.month() == moment(this.date, 'MM/DD/YYYY').month()) ? true : false,
                hasSchool: this.hasSchool(calendarIndex.format('MM/DD/YYYY')),
                hasEvents: this.hasEvents(calendarIndex.format('MM/DD/YYYY'))
            };
            calendarIndex.add(1, 'day');
        }
        let count = 0;
        // Check to see if we need the last row in the calendar
        for (let i = 35; i < this.calendarDates.length; i++) {
            if (this.calendarDates[i].isCurrentMonth == false) {
                count++;
            }
        }
        if (count == 7) {
            this.calendarDates.length = 35;
        }
    }

    changeMonth(action: string) {
        if (action == 'previous') {
            this.date = moment(this.date, 'MM/DD/YYYY').add(-1, 'month').format('MM/DD/YYYY');
        } else if (action == 'next') {
            this.date = moment(this.date, 'MM/DD/YYYY').add(1, 'month').format('MM/DD/YYYY');
        }
        this.monthChange.emit(this.date);
        this.populateCalendar();
    }

    hasSchool(date: string) {
        if (this.nonAttendanceDates) {
            return !this.nonAttendanceDates.includes(date);
        } else {
            return true;
        }
    }

    hasEvents(date: string) {
        if (this.eventDates) {
            return this.eventDates.includes(date);
        } else {
            return false;
        }
    }

    dayClicked(date: any) {
        this.dayClick.emit(date);
    }
}

export class CalendarDay {
    date: string;
    day: number;
    isToday: boolean;
    isCurrentMonth: boolean;
    hasSchool: boolean;
    hasEvents: boolean;
}
